import React, {Fragment} from 'react';
import { subDays } from 'date-fns';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Select from "react-select";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import parseHtml from 'html-react-parser';
import Common from "../../Common/Common";
import FormHeader from "../../Common/FormHeader";
import ListTable from "../../Common/ListTable";
import { statusOptions, typeOptions, exportRecordsCounts} from "./Constants";
import {
    convertUTCToLocalTime, 
    loadCustomFormData, 
    processSelectList, 
    randstr, 
    mobileNumberMusk,
    loadCustomCampaignandAutomationDate,
    exportFormData,
    showToast,
    prepareSearchString,
    formatDate,
    setSessionValue
} from "../../Common/Appcommon";
import Summary from "../../Common/Summary";
import CratioTooltip from "../../Common/CratioTooltip";
import requestApi from '../../services/requestApi.service';

class Analytics extends React.Component {

    formname = process.env.REACT_APP_CONVERSATION_FORMNAME;
    constructor(props) {
        super(props);
        let id = props.match === undefined || props.match.params.id === undefined ? '' : props.match.params.id;
        let type = props.match === undefined || props.match.params.type === undefined ? '' : props.match.params.type;
        // let statusName = (props.match && props.match.params && props.match.params.name) || '';
        let statusvalue = (props.match && props.match.params && props.match.params.status) || '';
        let defaultDate = [];
        if(!id && !type && !statusvalue){
            defaultDate['Sent_At'] = [subDays(new Date(), 6), new Date()];
        }
        let isUniqueDetails = false;
        if(type !== ""){
            isUniqueDetails = true;
        }
        this.state = {
            showLoader : false,
            page:1,
            limit: process.env.REACT_APP_RECORDS_PER_PAGE,
            totalCount: 0,
            formData: [],
            listFields : [],
            searchTxt : [],
            filterTxt : [],//{'Status' : 'All'},
            dateFilter : defaultDate,
            filterId : id,
            filterType : type,
            isUniqueDetails : isUniqueDetails,
            summary : [],
            openModal : false,
            exportLimit : exportRecordsCounts[1].value,
            isDisabled : false,
            status : statusvalue ?? '',
        };
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        await this.loadCampaignandAutomationDate();
        await this.loadFormData(false, false);
        await this.getAnalyticsSummary();
        this.setState({
            showLoader : false
        })
    };
    loadCampaignandAutomationDate = async () => {

        const {datevalues} =  await loadCustomCampaignandAutomationDate(          
            this.formname,
            this.state
        );
        let start = new Date(datevalues[0]);
        let endd = new Date(datevalues[1]);
        this.filterdate = [start, endd];
        let { dateFilter, filterId, filterType, status } = this.state;
        //dateFilter['Sent_At'] = [start, endd];
        if(!filterId && !filterType && !status){
            if(datevalues[0] === "" || datevalues[1] === "" || datevalues[0] === undefined || datevalues[1] === undefined ){
                dateFilter['Sent_At'] = [subDays(new Date(), 6), new Date()];
            }
        }
        this.setState({ dateFilter, isUniqueDetails: false });
    }
    loadFormData = async (issearch=false, showLoader = true) => {
        if(showLoader){
            this.setState({
                showLoader : true
            })
        }
        const { rowData , listFields, totalCount } =
            await loadCustomFormData(
            issearch,
            this.formname,
            this.state
        );

        this.setState({
            formData: rowData,
            listFields : listFields,
            totalCount : totalCount,
            showLoader : false
        })
    }

    handleSearch = async (name,value) => {

        let { searchTxt } = this.state;
        searchTxt[name] = value;
        await this.setState({searchTxt})
    }

    handleChange = async (name,selectedOptions) => {
        if(name === "Type"){
            this.setState({
                filterType : selectedOptions['value'],
                filterId : "0",
            });
        }else{
            let { filterTxt,page } = this.state;
            filterTxt = await processSelectList(filterTxt,name,selectedOptions);
            page = 1;
            this.setState({ filterTxt,page });
        }
    }

    handleDateChange = (name,selectedDates) => {
        let { dateFilter } = this.state;
        dateFilter[name] = selectedDates;
        this.setState({ dateFilter },async ()=>{
            await this.loadFormData(true);
            await this.getAnalyticsSummary();
        });
    }
    handleButtonClick = async (name,selectedDates) => {
        if(name === "search"){
            await this.loadFormData(true);
            await this.getAnalyticsSummary();
        }
    }

    onPageChange = async (page) => {
        this.setState({page},async ()=>{
            await this.loadFormData();
        });
    }

    getAnalyticsSummary = async () => {
        this.setState({
            showLoader : true
        })
        const { dateFilter, searchTxt, filterTxt, filterType, filterId, status } = this.state;
        let customCondition = "";

        if(filterType !== undefined && filterType !== "" && filterId !== "") {
            customCondition = filterType + "#" + filterId;
        }

        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "WHATSAPP_ANALYTICS_SUMMARY",
            "FORMNAME": this.formname,
            "customCondition" : customCondition,
            "datefilterEnabled" : filterId === "" || filterId === "0",
            "status": status
        };

        if(dateFilter['Sent_At'] != undefined && dateFilter['Sent_At'] != ''){
            params['FROM_DATE'] = `${formatDate(dateFilter['Sent_At'][0], "yyyy-mm-dd")} 00:00:00`;
            params['TO_DATE'] = `${formatDate(dateFilter['Sent_At'][1], "yyyy-mm-dd")} 23:59:00`;
        }
        if(searchTxt['To_Number'] !== undefined && searchTxt['To_Number'] !== ""){
            params['To_Number'] = searchTxt['To_Number'];
        }
        /* let searchStr = "";
        if(filterType.Status !== ""){
            searchStr = await prepareSearchString(searchStr, filterTxt, this.formname);
        }
        params['searchStr'] = searchStr; */

        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            setSessionValue("ANALYTICS_SUMMARY", JSON.stringify(response.data));
            this.setState({
                summary : response.data,
                showLoader : false
            });
        }else{
            handleErrorResponse(response.errormsg);
        }
    }


    onClickExports = async () => {
        let {totalCount, exportLimit} = this.state;

        if(totalCount === 0){
            showToast("No data found ", "top-right", "error");
        }else if(totalCount <= 20000){
            this.setState({
                showLoader : true
            })
            let filename = 'Whatsapp_Messages';
            await exportFormData(this.formname, this.state, filename, exportLimit);
            this.setState({
                showLoader : false
            })
        }else{
            this.handleExportChanges();
            //showToast("A maximum of 5000 records can be download", "top-right", "error");
        }
    }

    handleExportChanges = (name = "modal", e) => {
        if(name === "records"){
            let value = e.value;
            this.setState({
                exportLimit : value
            });
        }else{
            this.setState(prevState => ({
                openModal: !prevState.openModal,
                exportLimit : exportRecordsCounts[1].value
            }));
        }
    };
    
    handleExportClick = async (index, filename, start, exportLimit) => {
        if(index < 0){
            return;
        }
        this.setState({
            showLoader : true,
            isDisabled : true,
        }) 
        await exportFormData(this.formname, this.state, filename, exportLimit, start - 1);
        this.setState({
            showLoader : false,
            isDisabled : false,
        })
    }
    exportCSVModal = () => {
        let { totalCount, openModal, exportLimit, isDisabled } = this.state;
        let noofloops = Math.ceil(totalCount / exportLimit); // Use Math.ceil to avoid missing the last chunk
        let downloadList = [];
        let startcount = 1;

        for (let i = 0; i < noofloops; i++) {
            let endcount = Math.min(startcount + exportLimit - 1, totalCount); // Ensure endcount does not exceed totalCount
            downloadList.push([startcount, endcount]);
            startcount = endcount + 1;
        }
        return (
            <Modal isOpen={openModal} size={"lg"} toggle={this.handleExportChanges}>
                <ModalHeader toggle={this.handleExportChanges} className={`quickreply-inbox`}>
                        
                        <div>
                            <div className={`quickreply-inbox-header`}>
                                <span>Export as CSV</span>
                                {false && <Select
                                    onChange={(eve) => {
                                        this.handleExportChanges("records", eve)
                                    }}
                                    defaultValue={exportRecordsCounts[1]}
                                    options={exportRecordsCounts}
                                    className={"basic-multi-select col-md-4 mR10"}
                                    classNamePrefix={"le-select"}
                                    isClearable={false}
                                    isDisabled={isDisabled}
                                />}
                            </div>
                        </div>
                </ModalHeader>
                <ModalBody>
                    <div>
                        {
                            downloadList.length > 0 && 
                            downloadList.map((data, index) => {
                                let label = data[0] + " to " + data[1];
                                let filename = "Whatsapp Messages " + data[0] + " to " + data[1] + ".csv";
                                let name ="Download <strong>" + label +  "</strong> records as <strong>" + filename + "</strong>";
                                return(
                                    <Fragment key={index}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span>{parseHtml(name)}</span>
                                            <span title="Click to Download CSV" className={isDisabled ? 'cursor-wait' : 'cursor-p'} onClick={e => this.handleExportClick(isDisabled ? -1 : index, filename, data[0], exportLimit)}>
                                                <FontAwesomeIcon icon={faCloudArrowDown} />
                                            </span>
                                        </div>
                                        <hr />
                                    </Fragment>
                                )
                            })
                        }
                    </div>
                </ModalBody>
            </Modal>
        );
    };

    renderElements =  (name,formData,fields,childprops,childstate) => {

        if(name === 'type-Sent'){
            let typevalue = formData['Message_Type'];
            typevalue = formData['trigger_id'] != "" ? "Workflow" : typevalue; 
            let sentTime = formData['Sent_At'];
            sentTime = convertUTCToLocalTime(sentTime)
            return (
                <>
                    <div className={`d-grid `}>
                        <span className={'template-primary'}>{typevalue}</span>
                        <CratioTooltip title={'SENT AT'} id={1} content={<div className={'template-secondary'} ><span>{sentTime}</span></div>} />
                    </div>
                </>
            )
        }
        if(name === 'lead-name'){
            let leadName = formData['Leadname'] !== undefined ? formData['Leadname'] : "";
            let leadMobileNo = formData['To_Number'];
            leadMobileNo = mobileNumberMusk(leadMobileNo)
            return(
                <>
                    <div>
                        <div className={'template-primary'}>{leadName}</div>
                        <div className={'template-secondary'}>{leadMobileNo}</div>
                    </div>
                </>
            )
        }
        if(name === 'Status-Delivered'){
            let status = formData['Status'];
            let deliveryTime = formData['Delivered_At'];
            if(deliveryTime !== "") {
                deliveryTime = convertUTCToLocalTime(deliveryTime)
            } else {
                deliveryTime = "N/A";
            }
            return (
                <>
                    <div className={`d-grid `}>
                        <span className={'template-primary text-uppercase'}>{status}</span>
                        <CratioTooltip title={`${status !== undefined ? status.toUpperCase() : ''} AT`} id={randstr(`analytics_status_`)} content={<div className={'template-secondary'} ><span>{deliveryTime}</span></div>} />
                    </div>
                </>
            )
        }

    }

    /* shouldComponentUpdate(nextProps, nextState) {
        // Only re-render if shouldRenderSummary state has changed
        return nextState.shouldRenderSummary !== this.state.shouldRenderSummary;
    } */

    render(){
        if(this.state.isUniqueDetails){
            return <Common pageTitle={"Analytics"} showLoader={this.state.showLoader} mainContent={''}/>
        }
        let { formData, listFields, page, totalCount, limit, showLoader, dateFilter, summary, filterId, openModal, status } = this.state;
        let selIndex = '';
        let curURl = document.URL;
        let curURlDel = curURl.indexOf("delivered");
        let curURlRead = curURl.indexOf("read");
        let curURlSent = curURl.indexOf("sent");
        if(curURlSent >= 0){
            selIndex = 1;
        }else if(curURlDel >= 0){
            selIndex = 2;
        }else if(curURlRead >= 0){
            selIndex = 3;
        }
        if(listFields === undefined){
            return <></>
        }

        let customFieldConfig = {
            Template_Name:{
                "class": "template-message"
            },
            Category : {
                "capitalize" : true
            },
            Sent_At : {
                "toUTCDate" : true,
                "format" : `mmm dd, yyyy, HH:MM:ss TT`
            },
            Delivered_At : {
                "toUTCDate" : true,
                "format" : `mmm dd, yyyy, HH:MM:ss TT`
            },
            Read_At : {
                "toUTCDate" : true,
                "format" : `mmm dd, yyyy, HH:MM:ss TT`
            },
            Message_Type : {
                "render" : "type-Sent",
                "class" : "text-center"
            },
            To_Number : {
                "class" : "text-left",
                "render" : "lead-name",
            },
            Status : {
                "render" : "Status-Delivered",
                "class" : "text-center"
            }
        };

        let searchOptions = [
            {
                name : 'To_Number',
                placeHolder : 'Search by mobile no'
            }
        ];

        let selectOptions = [
            {
                'name' : 'Type',
                'options' : typeOptions,
                'multiple' : false,
                'defaultvalue' : selIndex === "" ? 0 : selIndex,
                'customClass' : filterId !== "" && filterId !== "0" ? "hide" : ""
            },
            {
                'name' : 'Status',
                'options' : statusOptions,
                'multiple' : false,
                'defaultvalue' : selIndex === "" ? 0 : selIndex,
                'customClass' : status ? "hide" : ""
            }
        ];

        let dateOptions = [
            {
                name : `Sent_At`,
                placeholder : `Select Date Range`,
                defaultValue : dateFilter['Sent_At'],
                customClass : filterId !== "" && filterId !== "0" ? "hide" : ""
            }
        ];
        let buttons = [
            {
                name : 'search',
                lable : 'Search',
                icon : faMagnifyingGlass
            }
        ]
        let headerFieldConfig = {
            RECIPIENT : {
                "class" : "text-left w-5",
            },
            TYPE : {
                "class" : "w-4"
            },
            STATUS : {
                "class" : "w-4"
            }
        };
        return (
            <Common pageTitle={"Analytics"} mainContent={
                <Fragment>
                    <div className="listview-container kv-main-wrapper h100per w-100">
                        <FormHeader
                            searchOptions={searchOptions}
                            selectOptions={selectOptions}
                            dateOptions={dateOptions}
                            buttonOptions={buttons}
                            handleDateChange={this.handleDateChange}
                            handleSearch={this.handleSearch}
                            handleSelectChange={this.handleChange}
                            handleBtnClick={this.handleButtonClick}
                            prefix={"analytics"}
                        />
                        <Summary
                            key={Math.random()}
                            formname={this.formname}
                            summaryData={summary}
                            type={"whatsapp_analytics"}
                        />
                        <div className='mw-330'>
                            <a className='a-tag-link-btn' onClick={e => this.onClickExports(e)}> Download as CSV </a>
                        </div>
                        <ListTable
                            key={Math.random()}
                            showRowCount={true}
                            spaceBfCell={false}
                            pagination={true}
                            showAccordian={false}
                            analyticsNeeded={true}
                            analyticsName={"MESSAGE"}
                            accordianName={'analytics-preview'}
                            noDataMsg={`Analytics not found`}
                            formData={formData}
                            fields={listFields}
                            config={customFieldConfig}
                            onPageChange={this.onPageChange}
                            currentPage={page}
                            totalCount={totalCount}
                            limit={limit}
                            customClass={'no-border-table'}
                            headerConfig={headerFieldConfig}
                            renderElements={this.renderElements}
                        />
                        {
                            openModal && this.exportCSVModal()
                        }
                    </div>
                    
                </Fragment>
            }  showLoader={showLoader} />
        )
    }

}

export default Analytics;
